<script setup lang="ts">
</script>

<template>
  <UtilsSection
    class="relative overflow-hidden bg-[#070d18] text-white"
    container-class="max-w-screen-xl"
  >
    <div
      class="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-[#27C9F4]/5 to-transparent pointer-events-none"
    />

    <div class="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
      <div class="relative order-2 lg:order-1" data-aos="fade-right">
        <div
          class="absolute -inset-4 bg-gradient-to-br from-[#27C9F4]/20 to-transparent rounded-3xl blur-2xl"
        />
        <img
          src="/images/author/mark-full-bw.png"
          alt="Marcos Santi Scheffel"
          class="relative w-full max-w-md mx-auto lg:mx-0 drop-shadow-2xl"
        />
      </div>

      <div class="order-1 lg:order-2 flex flex-col gap-6">
        <div data-aos="fade-up">
          <p
            class="text-[#27C9F4] uppercase tracking-[0.3em] text-xs font-medium mb-3"
          >
            {{ $t("author.eyebrow") }}
          </p>
          <UtilsTitle as="h2" class="text-white text-4xl md:text-5xl">
            {{ $t("author.title") }}
          </UtilsTitle>
        </div>

        <div
          class="h-px w-20 bg-gradient-to-r from-[#27C9F4] to-transparent"
          data-aos="fade-up"
        />

        <div
          class="flex flex-col gap-4 text-white/75 leading-relaxed"
          data-aos="fade-up"
        >
          <p>
            <strong class="text-white">Marcos Santi Scheffel</strong>
            {{ $t("author.description-p1") }}
          </p>
          <p>{{ $t("author.description-p2") }}</p>
          <p>{{ $t("author.description-p3") }}</p>
        </div>

        <div class="flex items-center gap-3 pt-2" data-aos="fade-up">
          <img
            src="/images/author/mark-portrait.jpg"
            alt=""
            class="w-14 h-14 rounded-full object-cover ring-2 ring-[#27C9F4]/50"
          />
          <div>
            <div class="font-neutron italic text-2xl text-[#FEE000]">
              Marcos Scheffel
            </div>
            <div class="text-sm text-white/50">{{ $t("author.role") }}</div>
          </div>
        </div>
      </div>
    </div>
  </UtilsSection>
</template>
